import React, { createContext, useContext, useState } from 'react';
// import { useNavigate } from 'react-router-dom';

const AuthContext = createContext(null);
const { localStorage } = window;

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('adminToken'));
  const [username, setUsername] = useState(() =>
    localStorage.getItem('adminUsername'),
  );
  const [role, setRole] = useState(() =>
    localStorage.getItem('adminRole') || 'admin',
  );

  function login(newToken, newUsername, newRole) {
    localStorage.setItem('adminToken', newToken);
    localStorage.setItem('adminUsername', newUsername);
    localStorage.setItem('adminRole', newRole || 'admin');
    setToken(newToken);
    setUsername(newUsername);
    setRole(newRole || 'admin');
  }

  function logout() {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUsername');
    localStorage.removeItem('adminRole');
    setToken(null);
    setUsername(null);
    setRole('admin');
  }

  return (
    <AuthContext.Provider value={{ token, username, role, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
